import React, { useEffect, useRef, useState } from 'react';
import './StatusFilterDropdown.css';

/**
 * Record-type filter for the ACRIS Documents table ("All Types").
 */
function AcrisTypeFilterDropdown(props) {
	const {
		onFilter,
		filteredType,
		types,
		isDisabled,
	} = props;

	const uniqueTypes = Array.from(
		new Set(
			(Array.isArray(types) ? types : [])
				.map((type) => String(type).trim())
				.filter(Boolean)
		)
	).sort((left, right) => left.localeCompare(right));

	const [isOpen, setIsOpen] = useState(false);
	const dropdownRef = useRef(null);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsOpen(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const handleSelect = (nextType) => {
		onFilter(nextType);
		setIsOpen(false);
	};

	const getDisplayText = (type) => {
		if (!type || type === 'all') {
			return 'All Types';
		}
		return type;
	};

	const getButtonClass = () => {
		if (!filteredType || filteredType === 'all') {
			return 'btn-success';
		}
		return 'btn-primary';
	};

	return (
		<div className="status-filter-dropdown" ref={dropdownRef}>
			<button
				disabled={isDisabled}
				className={`filter-button btn btn-sm ${getButtonClass()} dropdown-toggle px-2`}
				onClick={() => setIsOpen(!isOpen)}
			>
				{getDisplayText(filteredType)}
				<span className="caret"></span>
			</button>
			{isOpen && (
				<div className="status-filter-menu">
					<div
						className={`status-filter-item ${!filteredType || filteredType === 'all' ? 'active' : ''}`}
						onClick={() => handleSelect('all')}
					>
						All Types
					</div>
					{uniqueTypes.map((type) => (
						<div
							key={type}
							className={`status-filter-item ${filteredType === type ? 'active' : ''}`}
							onClick={() => handleSelect(type)}
						>
							{type}
						</div>
					))}
				</div>
			)}
		</div>
	);
}

export default AcrisTypeFilterDropdown;
